<template>
  <div class="about-container">
    <h1 class="about-title">Project Details</h1>
    <p class="about-description">
      Arina East Residences is an exclusive freehold development with 107 premium units at the city fringe, just 3 minutes from Katong Park MRT. Offering full condo facilities, modern interiors, smart home features, and Miele & Kohler fittings, it ensures luxury and convenience. Close to top schools, lifestyle hubs, and the Kallang Alive Master Plan, it boasts strong investment potential and seamless connectivity to the CBD and Changi Airport.
    </p>
    <h2 class="key-info-title">Key Development Info</h2>

    <!-- Cards Grid -->
    <v-container fluid class="pa-0">
      <v-row align="stretch">
        <v-col v-for="(detail, index) in projectDetails" :key="index" cols="12" sm="6" md="4">
          <v-card class="pa-4 fill-height d-flex flex-column">
            <v-card-title class="card-title">{{ detail.title }}</v-card-title>
            <v-card-text class="card-text flex-grow-1">{{ detail.description }}</v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'AboutView',
  props: {
    scrollToSection: Function, // Define the prop to accept the method
  },
  data() {
    return {
      projectDetails: [
        { title: 'Location', description: '6C & 6D Tanjong Rhu Road' },
        { title: 'Total Units', description: '107 residential units from 1-bedroom to 4-bedroom layouts.' },
        { title: 'Lease Period', description: 'Freehold' },
        { title: 'Developer', description: 'A Joint Venture by ZACD GROUP, FRAXTOR SINGAPORE & WELLTECH PTE LTD' },
        { title: 'Expected Completion', description: 'End 2028' },
        { title: 'Nearby Schools', description: 'Dunman High School, Chung Cheng High (Main)' }
      ],
    };
  },
});
</script>

<style scoped>
.about-container {
  padding: 20px;
  background-color: transparent; /* White background */
}

.about-title {
  font-size: 2.5rem;
  font-weight: bold;
  color: #2c3e50; /* Dark text color */
  margin-bottom: 20px;
  text-align: center;
}

.about-description {
  font-size: 1.1rem;
  color: #666; /* Subdued text color */
  line-height: 1.6;
  margin-bottom: 32px;
  text-align: center;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}

.key-info-title {
  font-size: 2rem;
  font-weight: bold;
  color: #2c3e50; /* Dark text color */
  margin-bottom: 24px;
  text-align: center;
}

.v-container {
  padding: 0 16px;
}

.v-row {
  margin: -8px; /* Adjust for gutter spacing */
}

.v-col {
  padding: 8px; /* Gutter spacing */
}

.v-card {
  background-color: #F7F4ED;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1); /* Subtle shadow */
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  height: 100%; /* Ensure all cards are the same height */
}

.v-card:hover {
  transform: translateY(-4px); /* Lift effect on hover */
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2); /* Enhanced shadow on hover */
}

.card-title {
  font-size: 1.25rem;
  font-weight: bold;
  color: #2c3e50; /* Primary color */
  margin-bottom: 12px;
}

.card-text {
  font-size: 1rem;
  color: #555; /* Subdued text color */
  line-height: 1.5;
}

/* Responsive Adjustments */
@media (max-width: 600px) {
  .about-title {
    font-size: 2rem; /* Smaller title on mobile */
  }

  .about-description {
    font-size: 1rem; /* Smaller description on mobile */
  }

  .key-info-title {
    font-size: 1.75rem; /* Smaller subtitle on mobile */
  }

  .card-title {
    font-size: 1.1rem; /* Smaller card title on mobile */
  }

  .card-text {
    font-size: 0.9rem; /* Smaller card text on mobile */
  }

  .v-container {
    padding: 0 8px; /* Reduce padding on mobile */
  }

  .v-col {
    padding: 4px; /* Reduce gutter spacing on mobile */
  }
}
</style>